import React from "react";

export function CountryIcon({ country }) {
    // noinspection SpellCheckingInspection
    return <div className={'timage countryicon'} data-country={country}></div>;
}

export function TravianIcon({ icon }) {
    return <div className={'timage travicon'} data-icon={icon}></div>;
}

export function GameIconTL() {
    return <TravianIcon icon={'16-game-icon-tl'} />
}

export function GameIconTK() {
    return <TravianIcon icon={'16-game-icon-tk'} />
}

export function TroopIcon({ tribe, t, troopId }) {
    if (typeof troopId !== 'undefined') {
        tribe = Math.floor((troopId - 1) / 10) + 1;
        t = (troopId - 1) % 10 + 1;
    }
    if (t.toString()[0] !== 't') {
        t = 't' + t;
    }
    return <div className="timage unitimage" data-tribe={tribe} data-unit={t}></div>
}

export function ResourceIcon({ resource }) {
    return <div className="timage ressimage" data-ress={"r" + resource}></div>
}

export function ResourcesIcon() {
    return <>
        <ResourceIcon resource={1} />
        <ResourceIcon resource={2} />
        <ResourceIcon resource={3} />
        <ResourceIcon resource={4} />
    </>
}
